module.exports = __webpack_public_path__ + "4aed32182658e39cd0401d5999d611c2.svg";